import type { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { logCheckoutException } from './checkout-sentry';

const stripePromises = new Map<string, Promise<Stripe | null>>();

const getStripe = (publishableKey?: string) => {
  // Stripe.js intentionally has no instance during server rendering.
  if (typeof window === 'undefined') return Promise.resolve(null);
  const key = publishableKey || process.env.NEXT_PUBLIC_STRIPE_KEY!;

  if (!stripePromises.has(key)) {
    stripePromises.set(key, Promise.resolve()
      .then(() => loadStripe(key))
      .then(stripe => {
        if (!stripe) throw new Error('Stripe.js did not initialize');
        return stripe;
      })
      .catch(error => {
        stripePromises.delete(key);
        logCheckoutException(error, 'stripe_js_load');
        return null;
      }));
  }

  return stripePromises.get(key)!;
};

export default getStripe;
